import React from 'react';

interface SkipBackButtonProps {
  mediaElementId: string;
  onClick: () => void;
}

export const SkipBackButton = React.memo(function SkipBackButton({ mediaElementId, onClick }: SkipBackButtonProps) {
  return (
    <button
      className="kollab-player-btn kollab-player-skip-back-btn"
      aria-label="Back 5 seconds"
      data-tooltip="Back 5 seconds"
      aria-controls={mediaElementId}
      onClick={onClick}
      type="button"
    >
      <span className="kollab-player-btn-icon" aria-hidden="true" />
    </button>
  );
});
